export const SECURED_API_BASE = '/api/secured';
export const PUBLIC_API_BASE = '/public';
